import type { MRT_ColumnDef } from "mantine-react-table-open";
import type {
  FlatLocationOverviewData,
  MarketOrMeteringLocationOverview
} from "../../LocationOverview.types";

function getMeteringDataColumns(): Array<
  MRT_ColumnDef<FlatLocationOverviewData>
> {
  return [
    getMeteringDataAvailabilityColumn(
      "Messwerte Verbrauch/Entnahme",
      "positive"
    ),
    getMeteringDataAvailabilityColumn(
      "Messwerte Erzeugung/Einspeisung",
      "negative"
    )
  ];
}

function getMeteringDataAvailabilityColumn(
  header: string,
  id: keyof NonNullable<MarketOrMeteringLocationOverview["assessment"]>
): MRT_ColumnDef<FlatLocationOverviewData> {
  return {
    accessorKey: `meteringData-${id}`,
    header: header,
    size: 205,
    enableGrouping: false,
    Cell: ({ row }) => {
      const { assessment } = row.original;
      return (
        <>
          Aktuelles Jahr:{" "}
          {getCurrentValueText(
            assessment === null ? null : assessment[id].currentYear
          )}
          <br />
          Aktueller Monat:{" "}
          {getCurrentValueText(
            assessment === null ? null : assessment[id].currentMonth
          )}
        </>
      );
    }
  };
}

function getCurrentValueText(value: number | null) {
  if (value === null) {
    return "-";
  }

  return `${value}%`;
}

export { getMeteringDataColumns };
